import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { ICrudGetAllAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './my-favourite.reducer';
import { IMyFavourite } from 'app/shared/model/my-favourite.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IMyFavouriteProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const MyFavourite = (props: IMyFavouriteProps) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { myFavouriteList, match, loading } = props;
  return (
    <div>
      <h2 id="my-favourite-heading">
        My Favourites
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp; Create new My Favourite
        </Link>
      </h2>
      <div className="table-responsive">
        {myFavouriteList && myFavouriteList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Video Meta Data</th>
                <th>User</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {myFavouriteList.map((myFavourite, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${myFavourite.id}`} color="link" size="sm">
                      {myFavourite.id}
                    </Button>
                  </td>
                  <td>
                    {myFavourite.videoMetaData ? (
                      <Link to={`video-meta-data/${myFavourite.videoMetaData.id}`}>{myFavourite.videoMetaData.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{myFavourite.user ? myFavourite.user.login : ''}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${myFavourite.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${myFavourite.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${myFavourite.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No My Favourites found</div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ myFavourite }: IRootState) => ({
  myFavouriteList: myFavourite.entities,
  loading: myFavourite.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(MyFavourite);
